export default {
  methods: {
    renderStoresBarLine(data) {
      const names = (data || []).map(d => d.storeName);
      const done = (data || []).map(d => d.greenQty || 0);
      const undone = (data || []).map(d => d.orangeQty || 0);
      const rate = (data || []).map(d => (d.finishRate && d.finishRate.replace('%', '')) || 0);
      const option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'line',
            lineStyle: {
              color: '#ccc',
              width: 1,
              type: [5, 10]
            },
            crossStyle: {
              color: '#ccc'
            }
          },
          formatter(params) {
            let result = `${params[0].axisValue}<br/>`;
            params.forEach(p => {
              // 手动创建marker图标
              const markerColor = p.color.colorStops ? p.color.colorStops[0].color : (p.color || '#ccc');
              const marker = `<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;background-color:${markerColor};"></span>`;
              
              // 如果是上架完成率，添加%号
              if (p.seriesName === '上架完成率') {
                result += `${marker}${p.seriesName}：${p.value}%<br/>`;
              } else {
                result += `${marker}${p.seriesName}：${p.value}<br/>`;
              }
            });
            return result;
          }
        },
        legend: {
          right: 0,
          textStyle: {
            color: '#fff',
            fontFamily: 'PingFangSC'
          },
          data: ['已上架商品', '未上架商品', '上架完成率']
        },
        grid: {
          left: 55,
          right: 55,
          top: 40,
          bottom: 20
        },
        dataZoom: [
          {
            type: 'inside',
            xAxisIndex: [0],
            start: 0,
            end: Math.min(100, (10 / Math.max(names.length, 1)) * 100)
          }
        ],
        xAxis: {
          type: 'category',
          data: names,
          axisLabel: {
            color: '#fff',
            fontSize: 12,
            fontFamily: 'PingFangSC',
            formatter: function(value) {
              if (value.length > 4) {
                return value.substring(0, 4) + '...';
              }
              return value;
            }
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.2)'
            }
          },
          axisTick: {
            show: false
          }
        },
        yAxis: [{
            type: 'value',
            min: 0,
            axisLine: {
              show: false
            },
            axisLabel: {
              color: '#fff',
              fontSize: 12,
              fontFamily: 'PingFangSC'
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
          },
          {
            type: 'value',
            min: 0,
            max: 100,
            axisLabel: {
              formatter: '{value} %',
              color: '#fff',
              fontSize: 12,
              fontFamily: 'PingFangSC'
            },
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            splitLine: {
              show: false
            },
          }
        ],
        series: [{
            name: '已上架商品',
            type: 'bar',
            barWidth: 16,
            data: done,
            itemStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: '#5BE18D'
                }, {
                  offset: 1,
                  color: 'rgba(15,180,152,0)'
                }]
              }
            }
          },
          {
            name: '未上架商品',
            type: 'bar',
            barWidth: 16,
            data: undone,
            itemStyle: {
              color: {
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: '#FCDB65'
                }, {
                  offset: 1,
                  color: 'rgba(253,209,96,0)'
                }]
              }
            }
          },
          {
            name: '上架完成率',
            type: 'line',
            yAxisIndex: 1,
            smooth: true,
            data: rate,
            symbol: 'none',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0,
                    color: 'rgba(255, 155, 0, 1)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(255, 155, 0,0.05)'
                  }
                ]
              }
            },
            lineStyle: {
              color: 'rgba(255, 155, 0, 1)',
              width: 2
            },
            itemStyle: {
              color: 'rgba(255, 155, 0, 1)'
            },
          }
        ]
      };
      const $instance = this.$echarts.init(this.$refs['storesBarLine']);
      this.$refs['storesBarLine'].removeAttribute('_echarts_instance_');
      $instance.setOption(option);
      window.onresize = $instance.resize;
    }
  }
}
